import React from "react";
import './assets/styles/custom.css';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import Home from "./pages/Home";
import AboutOrgavitaz from "./pages/AboutOrgavitaz";
import Portfolio from "./pages/Portfolio";
import ProductDetails from "./components/AdminDashboardComponents/ProductManagement/ProductDetails";
import Sustainability from "./pages/Sustainability";
import Contact from "./pages/Contact";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectRoute";
import Stories from "./pages/Stories";
import Certifications from "./pages/Certifications";
import ExternalUserLogin from "./components/PublicUserManagement/ExternalUserLogin";
import Services from "./pages/Services";
import BatchPublicView from "./components/PublicUserManagement/BatchPublicView";
import Register from "./components/PublicUserManagement/Register";
import OAuthSuccess from "./config/OAuthSuccess";
import UserDashboard from "./components/PublicUserManagement/UserDashboard";

// Wrapper to use location and hide layout on admin routes
function LayoutWrapper() {
  const location = useLocation();
  const hideNavbar = 
  location.pathname.startsWith("/AdminDashboard") || location.pathname.startsWith("/batch") || location.pathname.startsWith("/user-dashboard");
  const hideFooter =
  location.pathname.startsWith("/AdminDashboard");

  return (
    <div className="d-flex flex-column min-vh-100">
      {!hideNavbar && <Navbar />}
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<AboutOrgavitaz />} />
          <Route path="/Portfolio" element={ <Portfolio/>} />
          <Route path="/Services" element={<Services />} />
          <Route path="/product/:productCode" element={<ProductDetails />} />
          <Route path="/Sustainability" element={<Sustainability />} />
          <Route path="/Certifications" element={<Certifications/>} />
          <Route path="/Stories" element={<Stories />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/AdminLogin" element={<AdminLogin />} />
          <Route
            path="/AdminDashboard/*"
            element={
              <ProtectedRoute allowedRoles={['ADMIN', 'PRODUCT_MANAGER', 'DATA_CURATOR']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
            <Route path="/login" element={<ExternalUserLogin />} />
            <Route path="/register" element={<Register />} />

            <Route path="/user-dashboard" element={
                  <ProtectedRoute allowedRoles={['PUBLIC','CLIENT','DISTRIBUTOR']}>
                  <UserDashboard />
                  </ProtectedRoute>
                } />
            <Route path="/batch/:batchNumber" element={
              <ProtectedRoute allowedRoles={['PUBLIC','CLIENT','DISTRIBUTOR']}>
              <BatchPublicView />
              </ProtectedRoute>} />
            <Route path="/oauth-success" element={<OAuthSuccess />} />

        </Routes>
      </main>
      {!hideFooter && <Footer />}
      {!hideNavbar && (
        <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 9999 }}>
          <Chatbot />
        </div>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <LayoutWrapper />
    </Router>
  );
}

export default App;
